/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 */

import { FiSearch, FiX } from 'react-icons/fi'

/** A list page's search box, in the page's top row. */
export const ListSearch = ({
  id,
  placeholder,
  value,
  onChange,
}: {
  id: string
  placeholder: string
  value: string
  onChange: (value: string) => void
}) => (
  <div className="relative w-[150px] shrink-0">
    <input
      id={id}
      name={id}
      type="text"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="input input-bordered input-sm w-full pr-8 text-base-content"
    />
    {value ? (
      <button
        onClick={() => onChange('')}
        aria-label="Clear search"
        className="absolute right-2 top-1/2 -translate-y-1/2 text-base-content/50 hover:text-base-content"
      >
        <FiX className="w-4 h-4" />
      </button>
    ) : (
      <FiSearch className="absolute right-2 top-1/2 -translate-y-1/2 w-4 h-4 text-base-content/50" />
    )}
  </div>
)
